import { z } from 'zod';

export const PathModelType = z.enum([
  'DEFAULT',
  'PAGE',
  'NODE_ID',
  'SLIDE_ID',
  'SLIDE',
  'TRAINING',
  'USER_ID',
  'MODALITY_ID',
  'STAIN_ID',
  'COPYRIGHT_ID',
]);
export type PathModelType = z.infer<typeof PathModelType>;

export class DefaultPathModel {
  readonly type: PathModelType = PathModelType.enum.DEFAULT;
}

export class PagePathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.PAGE;
  page: string | null = null;
}

export class NodeIdPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.NODE_ID;
  id: string | null = null;
}

export class SlideSlideIdPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.SLIDE_ID;
  id: string | null = null;
}

export class SlidePathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.SLIDE;
  eLearning: string | null = null;
  subject: string | null = null;
  chapter: string | null = null;
  block: string | null = null;
  slide: string | null = null;
}

export class TrainingPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.TRAINING;
  eLearning: string | null = null;
  subject: string | null = null;
  chapter: string | null = null;
  block: string | null = null;
  slide: string | null = null;
}

export class UserIdPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.USER_ID;
  id: string | null = null;
}

export class ModalityIdPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.MODALITY_ID;
  id: string | null = null;
}

export class StainIdPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.STAIN_ID;
  id: string | null = null;
}

export class CopyrightIdPathModel extends DefaultPathModel {
  override readonly type = PathModelType.enum.COPYRIGHT_ID;
  id: string | null = null;
}

export type PathModel = DefaultPathModel | PagePathModel | NodeIdPathModel | SlidePathModel
  | TrainingPathModel | UserIdPathModel | ModalityIdPathModel | StainIdPathModel | CopyrightIdPathModel;
